function getInterlibraryLoans(apiClient, params) {
  const route = apiClient.route `/libraries/${':librarySubdomain'}/interlibraryloans`;
  return apiClient.get(route, { query: params });
}


export default {
  getInterlibraryLoans
};



// WEBPACK FOOTER //
// ./app/api/InterlibraryLoansApi.js